export default "__VITE_ASSET__8508d341__"